/* Dims LCSW (locale/country switcher widget)
   Externalized from snippets/dims-lcsw.liquid. Snippet may render twice
   (desktop + mobile) — initAll() runs against all [data-dims-lcsw] roots
   and init() is idempotent per element. */
(function () {
  function init(root) {
    if (root.__dimsLcswInited) return;
    root.__dimsLcswInited = true;
    var trigger  = root.querySelector('.dims-lcsw__trigger');
    var panel    = root.querySelector('.dims-lcsw__panel');
    var closeBtn = root.querySelector('.dims-lcsw__close');
    var form     = root.querySelector('form');
    var backdrop = root.parentElement && root.parentElement.querySelector('[data-dims-lcsw-backdrop]')
                || document.querySelector('[data-dims-lcsw-backdrop]');
    var isMobileInstance = root.classList.contains('dims-lcsw--mobile');
    if (!trigger || !panel) return;

    function isMobile() { return window.innerWidth <= 767; }

    function open() {
      trigger.setAttribute('aria-expanded', 'true');
      panel.removeAttribute('hidden');
      if (isMobile() && !isMobileInstance) {
        if (backdrop) backdrop.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    }
    function close() {
      trigger.setAttribute('aria-expanded', 'false');
      panel.setAttribute('hidden', '');
      if (backdrop) backdrop.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', function () {
      trigger.getAttribute('aria-expanded') === 'true' ? close() : open();
    });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop && !isMobileInstance) backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
        close(); trigger.focus();
      }
    });

    // Option click: set country + locale, then submit
    root.querySelectorAll('.dims-lcsw__opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var countryIn = root.querySelector('.dims-lcsw__country-input');
        var localeIn  = root.querySelector('.dims-lcsw__locale-input');
        if (countryIn) countryIn.value = btn.dataset.country;
        if (localeIn)  localeIn.value  = btn.dataset.locale;
        if (form) form.submit();
      });
    });

    // Close on outside click (desktop instance only, on desktop)
    if (!isMobileInstance) {
      document.addEventListener('click', function (e) {
        if (window.innerWidth > 767 && !root.contains(e.target)) close();
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-dims-lcsw]').forEach(init);
  }

  initAll();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    setTimeout(initAll, 0);
  }
})();
